import React from 'react';
import { Row, Col, Button, Alert } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ConsultarEstatus from '../../common/ConsultarEstatus';

const BotonesAccionRecibidas = ({ isActive, handleOpenModal, handleOpenGastoModal, idGasto, TipoDeComprobante, datosSellos, emisor, receptor, total }) => {
    return (
        <>
            {/* Mensaje cuando la factura ya está registrada como gasto */}
            {idGasto && idGasto > 0 && (
                <Row className="mt-3">
                    <Col>
                        <Alert variant="success" className="mb-3">
                            <i className="fas fa-check-circle me-2"></i>
                            Esta factura ya fue registrada como gasto (ID Gasto: {idGasto})
                        </Alert>
                    </Col>
                </Row>
            )}

            <Row className="mt-4">
                <Col className="d-flex flex-column flex-md-row justify-content-md-end gap-2">
                    <ConsultarEstatus
                        uuid={datosSellos?.UUID}
                        rfcEmisor={emisor?.Rfc}
                        rfcReceptor={receptor?.Rfc}
                        total={total}
                    />
                    {/* Solo mostrar el botón si no hay idGasto o es 0 */}
                    {(!idGasto || idGasto === 0 || TipoDeComprobante=='I') && (
                        <Button
                            variant="success"
                            onClick={handleOpenGastoModal}
                            className="px-4 text-white"
                            disabled={!isActive}
                        >
                            <i className="fas fa-receipt me-2"></i>
                            Registrar como Gasto
                        </Button>
                    )}
                    <Button
                        variant="warning"
                        onClick={() => handleOpenModal('cancelar')}
                        className="px-4"
                        disabled={!isActive}
                    >
                        <i className="fas fa-ban me-2"></i>
                        {isActive ? 'Cancelar Factura' : 'Ya Cancelada'}
                    </Button>
                    <Button
                        variant="danger"
                        onClick={() => handleOpenModal('eliminar')}
                        className="px-4"
                    >
                        <i className="fas fa-trash me-2"></i>
                        Eliminar Factura
                    </Button>
                </Col>
            </Row>
        </>
    );
};

BotonesAccionRecibidas.propTypes = {
    isActive: PropTypes.bool,
    handleOpenModal: PropTypes.func,
    handleOpenGastoModal: PropTypes.func,
    idGasto: PropTypes.number,
    TipoDeComprobante: PropTypes.string,
    datosSellos: PropTypes.object,
    emisor: PropTypes.object,
    receptor: PropTypes.object,
    total: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default BotonesAccionRecibidas;
